<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import uploadFile from "@/views/components/common/form/uploadFile.vue";
import { Input, Row, Col, ButtonGroup, Button } from "view-design";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "reverb",
      url: {},
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "回声树名称",
          name: "title",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        // {
        //   label: "时间",
        //   name: "update_time",
        //   value: "",
        //   type: "date",
        //   rules: [{ required: true, trigger: "blur" }],
        // },
      ],
    };
  },
  created() {},
  methods: {
    initData() {
      // 加载详情数据
      $form.initData(this, {}, (res) => {
        if (res) {
          this.forms = res;
          this.$forceUpdate();
        }
      });
    },
  },
};
</script>
